import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';

const HeaderTabBarLayout = ({ title, tabs, activeTab, onTabChange, onBack, children }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (onBack) {
            onBack();
        } else {
            navigate(-1);
        }
    };

    return (
        <div className="min-h-screen bg-white">
            {/* 헤더 */}
            <div className="fixed top-0 left-0 right-0 bg-white z-10">
                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200" style={{ minHeight: '65px' }}>
                    <button
                        onClick={handleBack}
                        className="p-2 -ml-2"
                    >
                        <IoChevronBack size={24} className="text-gray-700" />
                    </button>
                    <span className="text-lg font-semibold text-gray-800">{title}</span>
                    <div className="w-10"></div>
                </div>

                {/* 탭바 */}
                <div className="flex border-b border-gray-200">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => onTabChange(tab.id)}
                            className={`flex-1 py-3 text-sm font-medium relative ${
                                activeTab === tab.id
                                    ? 'text-amber-500'
                                    : 'text-gray-500'
                            }`}
                        >
                            {tab.name}
                            {activeTab === tab.id && (
                                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-amber-500"></div>
                            )}
                        </button>
                    ))}
                </div>
            </div>

            {/* 컨텐츠 */}
            <div className="pt-[113px] min-h-screen">
                {children}
            </div>
        </div>
    );
};

export default HeaderTabBarLayout;
